/* eslint-disable @typescript-eslint/no-explicit-any */
import { CssBaseline } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { QueryClientProvider } from "@tanstack/react-query";
import { SnackbarProvider } from "notistack";
import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import MainLayout from "./components/layout/MainLayout";
import Snackbars from "./components/snackbars";
import { InquiryDash, QUERY_CLIENT, } from "./consts";
import NotFoundPage from "./pages/NotFoundPage";
import { About, Privacy, TermsOfService, Inquire, Home } from "./consts";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicesPage";
import LandingPage from "./pages/LandingPage";
import InquiryDashboard from "./pages/InquiryDashboard";
import { AppThemeProvider } from "./Contexts/ThemeContext";
// QUERY_CLIENT.setQueryData(UseGetUserKeyFn(), (window as any).CURRENT_USER);
const root = ReactDOM.createRoot(document.getElementById("root"));
// Build routes based on auth state
const getRoutes = () => {
    const publicRoutes = [
        { path: Home, element: React.createElement(LandingPage, null) },
        { path: About, element: React.createElement(AboutPage, null) },
        { path: Privacy, element: React.createElement(PrivacyPolicyPage, null) },
        { path: TermsOfService, element: React.createElement(TermsOfServicePage, null) },
        { path: Inquire, element: React.createElement(ContactPage, null) },
        // { path: Investment, element: <InvestmentPage /> },
        { path: InquiryDash, element: React.createElement(InquiryDashboard, null) },
        // { path: ManagerGallery, element: <GalleriesPage /> },
    ];
    const routes = [
        {
            element: React.createElement(MainLayout, null),
            children: [...publicRoutes, { path: "*", element: React.createElement(NotFoundPage, null) }],
        },
    ];
    return routes;
};
const ROUTER = createBrowserRouter(getRoutes(), {
    future: {
        v7_relativeSplatPath: true,
        v7_fetcherPersist: true,
        v7_normalizeFormMethod: true,
        v7_partialHydration: true,
        v7_skipActionErrorRevalidation: true,
    },
});
root.render(React.createElement(React.StrictMode, null,
    React.createElement(QueryClientProvider, { client: QUERY_CLIENT },
        React.createElement(AppThemeProvider, null,
            React.createElement(SnackbarProvider, null,
                React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
                    React.createElement(CssBaseline, null),
                    React.createElement(Snackbars, null),
                    React.createElement(RouterProvider, { router: ROUTER, future: { v7_startTransition: true } })))))));
